export const LOGOUT_COMPLETED = 'LOGOUT_COMPLETED';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/logoutActionTypes.js